import Icon from '../components/Icon.vue'

Icon.register({
  'tachometer-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 32c159.1 0 288 128.9 288 288 0 52.8-14.3 102.3-39.1 144.8-5.6 9.6-16.3 15.2-27.4 15.2h-443c-11.1 0-21.8-5.6-27.4-15.2-24.8-42.5-39.1-92-39.1-144.8 0-159.1 128.9-288 288-288zM288 96c-17.7 0-32 14.3-32 32s14.3 32 32 32c6.7 0 12.5-2.5 17.6-6l9.2-27.7c0.8-2.4 2.3-4.4 3.5-6.7-3.7-13.5-15.6-23.7-30.3-23.7zM96 384c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM144 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM390.8 151.6c4.2-12.6-2.6-26.2-15.2-30.4-12.6-4.3-26.2 2.6-30.4 15.2l-61.3 184c-33.4 2.2-59.9 29.6-59.9 63.6 0 11.7 3.4 22.5 8.9 32h110.2c5.5-9.5 8.9-20.3 8.9-32 0-19.5-8.9-36.7-22.6-48.4zM405.4 208.8c5.7 8.9 15.2 15.2 26.6 15.2 17.7 0 32-14.3 32-32s-14.3-32-32-32c-3.9 0-7.6 0.9-11 2.2zM480 384c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tachometer-alt.js
// module id = 1982
// module chunks = 0